export const MODES = {
    CLASSIC: 'CLASSIC',
    AUTO: 'AUTO',
}

export const DEFAULT_ROUND_TIME = 60
export const ROUND_RESULT_TIME = 10
